<template>

</template>

<script>
export default {
  name: "index",
  created() {
    setInterval(() => {
      this.loading()
    }, 100)
  },
  methods: {
    loading: function () {
      let self = this;
        return true;
    }
  }
}
</script>

<style scoped>

</style>